import { AUTH_TYPE } from 'aws-appsync/lib'
import AWSAppSyncClient from 'aws-appsync'
import { Auth } from '@aws-amplify/auth'
import { Storage } from '@aws-amplify/storage'

const {
    REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT: awsAppSyncGraphQLEndpoint,
    REACT_APP_AWS_REGION: awsRegion,
    REACT_APP_COGNITO_DOMAIN,
    REACT_APP_COGNITO_REGION,
    REACT_APP_COGNITO_USER_POOL_ID,
    REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    REACT_APP_COGNITO_IDENTITY_POOL_ID,
    REACT_APP_BUCKET_NAME,
    REACT_APP_BUCKET_REGION,
    REACT_APP_FRONTEND_URL,
} = window.APP_CONFIG

/**
 * Init AWS configuration
 *
 * @return AWSAppSyncClient
 */
export const initAWS = () => Promise.resolve().then(() => {
    const oauth = {
        domain: `${REACT_APP_COGNITO_DOMAIN}.auth.${REACT_APP_COGNITO_REGION}.amazoncognito.com`,
        scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: REACT_APP_FRONTEND_URL + '/cognito/oauth/callback',
        redirectSignOut: REACT_APP_FRONTEND_URL + '/cognito/oauth/callback',
        responseType: 'code',
    }

    const client = new AWSAppSyncClient({
        url: awsAppSyncGraphQLEndpoint,
        region: awsRegion,
        auth: {
            type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
            jwtToken: async () => (await Auth.currentSession())?.getIdToken()?.getJwtToken(),
        },
        complexObjectsCredentials: () => Auth.currentCredentials(),
        disableOffline: true,
    })

    Auth.configure({
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        identityPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
        region: REACT_APP_COGNITO_REGION,
        userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
        oauth: oauth,
    })

    Storage.configure({
        AWSS3: {
            bucket: REACT_APP_BUCKET_NAME,
            region: REACT_APP_BUCKET_REGION,
            identityPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
        },
    })

    return client
})
